export enum TagEnum {
    // *a* = "<a>",
}
